import { render } from "./Presentation.vue?vue&type=template&id=90a4ac58&ts=true"
import script from "./Presentation.vue?vue&type=script&lang=ts"
export * from "./Presentation.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__